import axios from "axios";
import config from "./config";

const api = axios.create({
  baseURL: config.SERVER_URL,
  timeout: 15000,
});

// Inject admin key ke setiap request
api.interceptors.request.use((req) => {
  const key = localStorage.getItem("admin_key") || config.ADMIN_KEY;
  req.headers["X-Admin-Key"] = key;
  return req;
});

export default api;
